import { postRequest } from '@/core';
import { orders } from '@/requests';

export default async function(id) {
	let url = orders.openTmsR10Path(id);
	let response = await postRequest(url);
	return response;
}
